import React from 'react';
import { Redirect } from 'react-router-dom';
import { onboardingBrokerLoginRoute } from 'src/routing/routes';
import useBrokerLogin from 'src/hooks/useBrokerLogin';
import { FullPageLoader } from 'src/components';
import './check_sales_org.scss';

// This shouldn't be a component
export function CheckSalesOrg() {
  const { isValidBroker, validateBroker, getSalesOrgs, salesOrganizations } = useBrokerLogin();

  React.useEffect(() => {
    let queryString = new URLSearchParams(window.location.search);
    const salesOrg = localStorage.getItem('sales_org');
    sessionStorage.setItem('sales_org', queryString.get('sales_org'));

    if (queryString.get('sales_org')) {
      localStorage.setItem('sales_org', queryString.get('sales_org'));
    }

    if (queryString.get('sales_org') || salesOrg) {
      validateBroker(queryString.get('sales_org') || salesOrg);
    }

    if (!queryString.get('sales_org') && !salesOrg) {
      getSalesOrgs();
    }
  }, [validateBroker]);

  if (salesOrganizations.length > 0 || isValidBroker || isValidBroker !== null)
    return <Redirect to={onboardingBrokerLoginRoute} />;

  return <FullPageLoader showLoader={!isValidBroker} />;
}
